var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{staticClass:"video-js vjs-default-skin",attrs:{"id":"myVideo","playsinline":""}})])
}]

export { render, staticRenderFns }